// extracted by mini-css-extract-plugin
export default {"icon":"TheFooter_icon_FbrSN","logo":"TheFooter_logo_zyj_m","link":"TheFooter_link_ZgB5r"};